import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Hook to manage focus for screen reader accessibility on route changes.
 * Focuses the main heading when the route changes to announce the new page as react-router doesn't do this automatically - use on h1 refs.
 */
export function useFocusManagement() {
  const location = useLocation()
  const focusRef = useRef<HTMLHeadingElement>(null)

  useEffect(() => {
    // Focus the heading ref after route change to announce the new page to screen readers
    const timer = setTimeout(() => {
      if (focusRef.current) {
        focusRef.current.focus()
      }
    }, 100) // delay to ensure DOM is updated

    return () => clearTimeout(timer)
  }, [location.pathname])

  return focusRef
}
